import store from '../../../core/store';

const planningEndpoint = (path, isSystem = false) =>
  `${isSystem ? '/superadmin' : ''}${path}`;

export const listPlanningLibraryItems = (
  type,
  isSystem = false,
  activeOnly = false,
) => {
  return store.dispatch({
    action: 'table.planning_library/LIST_PLANNING_LIBRARY_ITEMS',
    method: 'GET',
    endpoint: planningEndpoint(
      `/planning-library-items?type=${type}${activeOnly ? '&active=1' : ''}`,
      isSystem,
    ),
  });
};

export const readPlanningLibraryItem = (id, isSystem = false) => {
  return store.dispatch({
    action: 'table.planning_library/READ_PLANNING_LIBRARY_ITEM',
    method: 'GET',
    endpoint: planningEndpoint(`/planning-library-items/${id}`, isSystem),
  });
};

export const createPlanningLibraryItem = (formData, isSystem = false) => {
  return store.dispatch({
    action: 'table.planning_library/CREATE_PLANNING_LIBRARY_ITEM',
    method: 'POST',
    endpoint: planningEndpoint('/planning-library-items', isSystem),
    data: formData,
  });
};

export const updatePlanningLibraryItem = (
  id,
  formData,
  isSystem = false,
) => {
  return store.dispatch({
    action: 'table.planning_library/UPDATE_PLANNING_LIBRARY_ITEM',
    method: 'PUT',
    endpoint: planningEndpoint(`/planning-library-items/${id}`, isSystem),
    data: formData,
  });
};

export const deletePlanningLibraryItem = (id, isSystem = false) => {
  return store.dispatch({
    action: 'table.planning_library/DELETE_PLANNING_LIBRARY_ITEM',
    method: 'DELETE',
    endpoint: planningEndpoint(`/planning-library-items/${id}`, isSystem),
  });
};

export const reorderPlanningLibraryItems = (type, items) => {
  return store.dispatch({
    action: 'table.planning_library/REORDER_PLANNING_LIBRARY_ITEMS',
    method: 'PUT',
    endpoint: '/planning-library-items/reorder',
    data: {
      type,
      items,
    },
  });
};

export const listPlanningTemplates = (isSystem = false) => {
  return store.dispatch({
    action: 'table.planning_library/LIST_PLANNING_TEMPLATES',
    method: 'GET',
    endpoint: planningEndpoint('/planning-templates', isSystem),
  });
};

export const readPlanningTemplate = (id, isSystem = false) => {
  return store.dispatch({
    action: 'table.planning_library/READ_PLANNING_TEMPLATE',
    method: 'GET',
    endpoint: planningEndpoint(`/planning-templates/${id}`, isSystem),
  });
};

export const createPlanningTemplate = (formData, isSystem = false) => {
  return store.dispatch({
    action: 'table.planning_library/CREATE_PLANNING_TEMPLATE',
    method: 'POST',
    endpoint: planningEndpoint('/planning-templates', isSystem),
    data: formData,
  });
};

export const updatePlanningTemplate = (id, formData, isSystem = false) => {
  return store.dispatch({
    action: 'table.planning_library/UPDATE_PLANNING_TEMPLATE',
    method: 'PUT',
    endpoint: planningEndpoint(`/planning-templates/${id}`, isSystem),
    data: formData,
  });
};

export const duplicatePlanningTemplate = (
  id,
  formData = {},
  isSystem = false,
) => {
  return store.dispatch({
    action: 'table.planning_library/DUPLICATE_PLANNING_TEMPLATE',
    method: 'POST',
    endpoint: planningEndpoint(
      `/planning-templates/${id}/duplicate`,
      isSystem,
    ),
    data: formData,
  });
};

export const deletePlanningTemplate = (id, isSystem = false) => {
  return store.dispatch({
    action: 'table.planning_library/DELETE_PLANNING_TEMPLATE',
    method: 'DELETE',
    endpoint: planningEndpoint(`/planning-templates/${id}`, isSystem),
  });
};
